import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import { useAuthStore } from '/src/stores/authStore';

const pinia = createPinia()
const app = createApp(App)

app.use(pinia)
// Load tokens from storage immediately after setting up Pinia
const authStore = useAuthStore();
authStore.loadTokensFromStorage();

app.use(router)
app.mount('#app')

if (window.performance && window.performance.navigation.type === window.performance.navigation.TYPE_RELOAD) {
    // Check if URL already has a version parameter
    const url = new URL(window.location.href);
    if (!url.searchParams.has('v')) {
        url.searchParams.set('v', Date.now());
        window.location.href = url.toString();
    }
}